import canUseDom from '@clearscore/helpers.can-use-dom';

const CACHE_NAME = '__cs__';

export default function getRelease() {
    if (!canUseDom() || !window[CACHE_NAME] || !window[CACHE_NAME].release) return {};
    return window[CACHE_NAME].release;
}
